import { Link } from 'react-router';
import { Fragment } from 'react';

import { AppKindEnum } from 'src/graphql/schema';
import { type IAppsQuery } from 'src/graphql/actions/apps/apps.query';
import { AppAvatar, UnclaimedBadge } from 'src/widgets/AppCard';
import { Badge } from '@/components/ui/badge';

import ActiveProtections from './ActiveProtections';

type Props = {
  app: IAppsQuery['apps']['nodes'][number];
};

const ApplicationRow = ({ app }: Props) => (
  <li>
    <Link
      to={`/applications/${app.id}`}
      className="flex items-center gap-3 rounded-md py-3 px-6 transition-colors hover:bg-accent/50"
    >
      <AppAvatar
        appId={app.id}
        name={app.name ?? null}
        claimed={!app.unclaimed}
        shape={app.owned ? 'circle' : 'rounded-square'}
        logoUrl={app.logoUrl ?? undefined}
        size="sm"
      />
      <div className="min-w-0 grow space-y-0.5">
        {app.unclaimed ? (
          <Fragment>
            <div className="text-sm font-medium text-slate-400">Application name</div>
            <UnclaimedBadge />
          </Fragment>
        ) : (
          <Fragment>
            <div className="truncate text-sm font-bold text-foreground">{app.name}</div>
            <div className="flex items-center gap-1.5">
              <span className="text-xs text-muted-foreground">{app.owned ? 'Your' : 'Vendor'} application</span>
              {app.kind === AppKindEnum.Suite && (
                <Badge className="rounded px-1 py-0 text-2xs leading-4 tracking-[0.04em] uppercase">
                  {AppKindEnum.Suite}
                </Badge>
              )}
            </div>
          </Fragment>
        )}
      </div>
      <ActiveProtections appId={app.id} />
    </Link>
  </li>
);

export default ApplicationRow;
